import { apiAuth, apiResponseType } from ".";

export const getClientCategoriesData = (page: number = 1): apiResponseType =>
  apiAuth.get(`client-categories?page=${page}`);

export const registerClientCategoriesData = (data) =>
  apiAuth.postForm("/client-categories/store", data) as apiResponseType;
export const deleteClientCategoriesData = (tenid: string) =>
  apiAuth.delete(`client-categories/${tenid}/destroy`) as apiResponseType;
export const updateClientCategoriesData = (tenid: string, data) =>
  apiAuth.postForm(
    `client-categories/${tenid}/update`,
    data
  ) as apiResponseType;

export const getShowClientCategories = (tenid: string) =>
  apiAuth.get(`client-categories/${tenid}/show`) as apiResponseType;

export const searchClientCategoriesData = (params: {
  name: string;
}): apiResponseType => apiAuth.get(`client-categories?name=${params.name}`);

export const setStatusClientCategories = (tenid: string) =>
  apiAuth.put(`client-categories/${tenid}/toggle-status`) as apiResponseType;

export const getSelectClientCategories = () =>
  apiAuth.get(`client-categories/select`) as apiResponseType;
